import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }

import { ref, onMounted,getCurrentInstance } from 'vue'
import { getMovieOrderDetailApi } from '@/apis/order'
import { useRoute } from 'vue-router'
import { OrderStatus } from './enum'


export default /*@__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const {proxy} = getCurrentInstance() as any
const route = useRoute()
const isReadonly = route.fullPath.includes('movie-show')

const orderId = route.query.id as string

const orderInfo = ref<any>({})
const getOrderDetail = async () => {
    const { code, data, msg } = await getMovieOrderDetailApi({ id: orderId }) as any
        
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    orderInfo.value = {
        ...data.order,
        order_amount: `总额:${parseFloat(data.order.blance_money)} 实付:${data.order.final_amount} 余额:${data.order.user_money_paid} 红包:${data.order.user_money_paid}`
    }
}

onMounted(() => {
    getOrderDetail()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: orderInfo.value,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "订单号" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: orderInfo.value.order_no,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((orderInfo.value.order_no) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "用户" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: orderInfo.value.username,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((orderInfo.value.username) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "订票手机号" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: orderInfo.value.device_no,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((orderInfo.value.device_no) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "下单时间" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: orderInfo.value.created_at,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((orderInfo.value.created_at) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "用户当前余额" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: orderInfo.value.totalMoney,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((orderInfo.value.totalMoney) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "城市" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: orderInfo.value.city,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((orderInfo.value.city) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "影城" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: orderInfo.value.cinema,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((orderInfo.value.cinema) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "电影" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: orderInfo.value.movie,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((orderInfo.value.movie) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "影厅" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: orderInfo.value.saloon,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((orderInfo.value.saloon) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "座位号" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: orderInfo.value.seats,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((orderInfo.value.seats) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "数量" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: orderInfo.value.quantity,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((orderInfo.value.quantity) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "订单金额" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: orderInfo.value.order_amount,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((orderInfo.value.order_amount) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "订单状态" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: orderInfo.value.status,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((orderInfo.value.status) = $event)),
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "未支付",
                          value: _unref(OrderStatus)['未支付']
                        }, null, 8, ["value"]),
                        _createVNode(_component_el_option, {
                          label: "已支付",
                          value: _unref(OrderStatus)['已支付']
                        }, null, 8, ["value"]),
                        _createVNode(_component_el_option, {
                          label: "已出票",
                          value: _unref(OrderStatus)['已出票']
                        }, null, 8, ["value"]),
                        _createVNode(_component_el_option, {
                          label: "出票失败待退款",
                          value: _unref(OrderStatus)['出票失败待退款']
                        }, null, 8, ["value"]),
                        _createVNode(_component_el_option, {
                          label: "已退款",
                          value: _unref(OrderStatus)['已退款']
                        }, null, 8, ["value"]),
                        _createVNode(_component_el_option, {
                          label: "已取消",
                          value: _unref(OrderStatus)['已取消']
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "开场时间" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: orderInfo.value.time,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((orderInfo.value.time) = $event)),
              disabled: "",
              style: {"color":"red"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { type: "default" }, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [
                _createTextVNode("取消")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_el_table, {
      data: orderInfo.value.logs,
      border: "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "msg",
          label: "订单日志"
        }),
        _createVNode(_component_el_table_column, {
          prop: "admin_name",
          label: "操作人"
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "操作时间"
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}
}

})